module.exports = __webpack_public_path__ + "img/info.46858da2.svg";